import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { createTheme, MuiThemeProvider } from '@material-ui/core/styles';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import ArrowRight from '@material-ui/icons/ArrowRight';
import EventConfiguration from '../FlowConfigurationInputs/EventConfiguration/EventConfiguration';
import ActiveDirectory from './ActiveDirectory';
import 'prismjs/components/prism-powershell';
import Database from './Database';
import Automs from './Automs';
import Excel from './Excel';
import Word from './Word';
import Repeatable from './Repeatable';
import RESTful from './RESTful';
import TimeManagement from './TimeManagement';
import Condition from './Condition';
import String from './String';
import DataTable from './DataTable';
import Dictionary from './Dictionary';
import Array from './Array';
import ServiceDesk from './ServiceDesk';
import DisplayMessage from './DisplayMessage';
import File from './File';
import Pdf from './Pdf';
import Folder from './Folder';
import Number from './Number';
import Ocr from './Ocr';
import Ews from './EWS';
import Email from './Email';
import Data from './Data';
import PreProcessing from './PreProcessing';
import Models from './Models';
import EndPoint from './EndPoint';
import DesktopRecorder from './DesktopRecorder';
import Stop from './Stop';
import Grouping from './Grouping';
import Python from './Python';
import Javascript from './Javascript';
import PowerShell from './PowerShell';
import Object from './Object';
import Csv from './CSV';
import DateAction from './Date';
import AdvancedActions from './AdvancedActions';
import CustomAction from './CustomAction';
import Whatsapp from './Whatsapp';
import { types } from './types';
import { useSetRecoilState, useRecoilState } from 'recoil';
import { alertState, lastFocusField, selectedField, inputRefresh, triggerConf, showObjectExplorerIcon } from '../../recoil-store/recoil-state';
import './FlowConfiguration.css';
import TriggerStatic from "./TriggerStatic";

import ConnectorField from "../../home/pages/automs/newFlow/middleArea/connectorField/ConnectorField";

const Libraries = (props) => {
    const { t } = useTranslation();
    const setAlert = useSetRecoilState(alertState);
    // const setInputRefreshGlobal = useSetRecoilState(inputRefresh);
    const [triggerConfig, setTriggerConfig] = useRecoilState(triggerConf);

    //const [triggerConfig, setTriggerConfig] = useState(null);


    const setFocusField = useSetRecoilState(lastFocusField);
    const [showOEIcon, setShowOEIcon] = useRecoilState(showObjectExplorerIcon);

    //const [selectedFieldValue] = useRecoilState(selectedField);
    // const sysActionFielName = 'sys_action_fields';

    // useEffect(() => {
    //     if (selectedFieldValue.path.length && focusField.inputName) {

    //         const valueEndIndex = selectedFieldValue.path.indexOf('[')
    //         let firstValue;
    //         let secondValue;
    //         if (valueEndIndex !== -1) {
    //             firstValue = selectedFieldValue.path.substring(2, valueEndIndex)
    //             secondValue = selectedFieldValue.path.substring(valueEndIndex)
    //         } else {
    //             firstValue = selectedFieldValue.path.substring(2, selectedFieldValue.path.length - 2)
    //             secondValue = selectedFieldValue.path.substring(selectedFieldValue.path.length - 2);
    //         }
    //         let v;
    //         if (selectedFieldValue.key === '') {
    //             v = `##${firstValue}${secondValue}`;
    //         } else {
    //             v = `##${selectedFieldValue.key}[${firstValue}]${secondValue}`;
    //         }
    //         if (!focusField.is_sys_field) {
    //             if (props.selectedAction.fields[focusField.inputName].value) {
    //                 props.selectedAction.fields[focusField.inputName].value += v;
    //             } else {
    //                 props.selectedAction.fields[focusField.inputName].value = v;
    //             }

    //         } else {
    //             props.selectedAction.fields[sysActionFielName].value[focusField.inputName].value = v;
    //         }
    //         setInputRefreshGlobal(new Date());
    //     }
    // }, [selectedFieldValue])

    useEffect(() => {
        if (props.fromFlow) {
            if (!showOEIcon) {
                setShowOEIcon(true)
            }
        } else {
            if (showOEIcon) {
                setShowOEIcon(false)
            }
        }
        setFocusField({
            inputName: '',
            type: '',
            is_sys_field: false
        })
    }, [props.selectedAction?.id])

    const showAlert = (message, status = false) => {
        setAlert(alert => ({ ...alert, show: true, message, severity: status ? 'success' : 'error' }));
    };

    const closeRightArea = () => {
        props.setShowRightArea(false);
        props.setShowTriggerRightArea(false);
    }

    const ConfigurationContent = (action) => {
        if (action) {
            action.mate_id = props.mateId;
            if (!action.fields) {
                action.fields = {};
            }
            if (action?.libraryLabel?.includes('CUSTOM')) {
                return CustomAction(action, showAlert, props.variables, props.setOpenVariable, props.variableRender, props.debuggingStart, props.debuggingExpand, props.automVersionId, props.automId, props.setVariables);
            }
            switch (action.libraryName) {
                case types.ACTIVEDIRECTORY:
                    return ActiveDirectory(action, showAlert, props.variables, props.setOpenVariable, props.variableRender, props.automId, props.automVersionId);
                case types.AUTOMS:
                    return Automs(action, showAlert, props.variables, props.setOpenVariable, props.findElementName, props.getAutomNamesIDs);
                case types.DATABASE:
                    return Database(action, showAlert, props.variables, props.setOpenVariable, props.variableRender);
                case types.EXCEL:
                    return Excel(action, showAlert, props.variables, props.setOpenVariable);
                case types.WORD:
                    return Word(action, showAlert, props.variables, props.setOpenVariable);
                case types.REPEAT:
                    return Repeatable(action, showAlert, props.variables, props.setOpenVariable, props.variableRender);
                case types.RESTFUL:
                    return RESTful(action, showAlert, props.variables, props.setOpenVariable, props.automId, props.automVersionId);
                case types.TIME:
                    return TimeManagement(action, showAlert, props.variables, props.setOpenVariable);
                case types.CONDITION:
                    return Condition(action, showAlert, props.variables, props.setOpenVariable, props.variableRender);
                case types.STRING:
                    return String(action, showAlert, props.variables, props.setOpenVariable, props.variableRender, props.setField, props.disabled, props.outputVisible);
                case types.DATATABLE:
                    return DataTable(action, showAlert, props.variables, props.setOpenVariable);
                case types.DICTIONARY:
                    return Dictionary(action, showAlert, props.variables, props.setOpenVariable);
                case types.ARRAY:
                    return Array(action, showAlert, props.variables, props.setOpenVariable, props.automId);
                case types.SERVICEDESK:
                    return ServiceDesk(action, showAlert, props.variables, props.setOpenVariable, props.variableRender, props.automVersionId);
                case types.DISPLAYMESSAGE:
                    return DisplayMessage(action, showAlert, props.variables, props.setOpenVariable, props.automId, props.variableRender);
                case types.FILE:
                    return File(action, showAlert, props.variables, props.setOpenVariable, props.automId, props.variableRender);
                case types.PDF:
                    return Pdf(action, showAlert, props.variables, props.setOpenVariable, props.automId, props.variableRender, props.automVersionId);
                case types.FOLDER:
                    return Folder(action, showAlert, props.variables, props.setOpenVariable, props.automId, props.variableRender);
                case types.NUMBER:
                    return Number(action, showAlert, props.variables, props.setOpenVariable, props.automId, props.variableRender, props.setField, props.disabled, props.outputVisible);
                case types.OCR:
                    return Ocr(action, showAlert, props.variables, props.setOpenVariable, props.automId, props.variableRender);
                case types.EWS:
                    return Ews(action, showAlert, props.variables, props.setOpenVariable, props.automId, props.variableRender);
                case types.EMAIL:
                    return Email(action, showAlert, props.variables, props.setOpenVariable, props.automId, props.variableRender);
                case types.DATA:
                    return Data(action, showAlert, props.variables, props.setOpenVariable, props.automId, props.variableRender);
                case types.PREPROCESSING:
                    return PreProcessing(action, showAlert, props.variables, props.setOpenVariable, props.variableRender, props.automVersionId);
                case types.MODELS:
                    return Models(action, showAlert, props.variables, props.setOpenVariable, props.automId, props.variableRender);
                case types.ENDPOINT:
                    return EndPoint(action, showAlert, props.variables, props.setOpenVariable, props.findElementName, props.getAutomNamesIDs, props.allFlow);
                case types.DESKTOPACTIONS:
                    return DesktopRecorder(action, showAlert, props.variables, props.setOpenVariable, props.drecorder, props.setRender, props.automId, props.actions, props.automVersionId);
                case types.STOP:
                    return Stop(action, showAlert, props.variables, props.setOpenVariable, props.automId, props.variableRender);
                case types.GROUPING:
                    return Grouping(action, showAlert, props.variables, props.setOpenVariable, props.variableRender, props.setGroupLabel);
                case types.PYTHON:
                    return Python(action, showAlert, props.variables, props.setOpenVariable, props.variableRender, props.setGroupLabel);
                case types.JAVASCRIPT:
                    return Javascript(action, showAlert, props.variables, props.setOpenVariable, props.variableRender, props.setGroupLabel);
                case types.OBJECT:
                    return Object(action, showAlert, props.variables, props.setOpenVariable, props.automId, props.variableRender, props.disabled);
                case types.CSVTEXT:
                    return Csv(action, showAlert, props.variables, props.setOpenVariable, props.automId, props.variableRender);
                case types.POWERSHELL:
                    return PowerShell(action, showAlert, props.variables, props.setOpenVariable, props.variableRender, props.setGroupLabel);
                case types.DATE:
                    return DateAction(action, showAlert, props.variables, props.setOpenVariable, props.automId, props.variableRender);
                case types.ADVANCEDACTIONS:
                    return AdvancedActions(action, showAlert, props.variables, props.setOpenVariable, props.automId, props.variableRender);
                case types.TRIGGERSTATIC:
                    return TriggerStatic(action, showAlert, props.variables, props.setOpenVariable, props.automId, props.variableRender, props.automVersionId);
                case types.WHATSAPP:
                    return Whatsapp(action, showAlert, props.variables, props.setOpenVariable, props.automId, props.automVersionId, props.variableRender, props.automaticallyWhatsappVariableCreation);
                default:
                    break;
            }
        }
    };
    const label = 'CONTENT.CONFIGURATION-FORM.' + props.selectedAction?.libraryName + '.';
    const actionName = label + props.selectedAction?.actionName;
    return (
        <MuiThemeProvider theme={getMuiTheme()}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <div id="configuration-container">
                    <div id={props.selectedAction?.actionName ? 'configuration-header' : 'without-header'}>
                        {
                            props.selectedAction?.actionName &&
                            <span>
                                {props.selectedAction?.libraryLabel?.includes('CUSTOM') ? props.selectedAction?.libraryName :
                                    <span>{t(label + 'HEADER')}</span>}
                                {props.selectedAction?.libraryLabel !== 'TRIGGERSTATIC' &&
                                    <span>&nbsp; &gt; &nbsp;</span>}
                                {props.selectedAction?.libraryLabel === 'TRIGGERSTATIC' ? "" :
                                    props.selectedAction?.libraryLabel?.includes('CUSTOM') ? props.selectedAction?.actionName :
                                        <span>{t(actionName + '.HEADER')}</span>}
                            </span>
                        }
                        {
                            props.setShowRightArea &&
                            <div className="close-menu" onClick={closeRightArea}>
                                <ArrowRight style={{ marginTop: 6, color: '#959595' }} />
                            </div>
                        }
                    </div>
                    <hr id="configuration-seperator" />
                    <div>{ConfigurationContent(props.selectedAction)}</div>
                    {
                        props.fromFlow && !props.selectedAction?.libraryLabel?.includes('CUSTOM') && props.selectedAction?.actionName !== 'START' && //triggerConfig?.connector?.id &&
                        <ConnectorField action={props.selectedAction} showFieldPreview={true}
                            triggerConfig={triggerConfig} triggerExpanded={true}
                            debugOpen={props.debuggingStart} debugExpand={props.debuggingExpand}
                            onFlowPage={true}
                            setTriggerConf={setTriggerConfig} automId={props.automId}
                            automVersionId={props.automVersionId} rightLocation={true}
                            variables={props.variables} setOpenVariable={props.setOpenVariable} />
                    }
                    {props.selectedAction?.actionName && !props.outputVisible &&
                        <EventConfiguration setField={props.setField} action={props.selectedAction} variables={props.variables} setOpenVariable={props.setOpenVariable} />}
                </div>

            </MuiPickersUtilsProvider>
        </MuiThemeProvider>
    );
};

export default Libraries;

const getMuiTheme = () => createTheme({
    overrides: {
        MuiOutlinedInput: {
            input: { padding: '8px 5px' },
            multiline: { padding: '8px 5px' }
        },
        MuiInputLabel: {
            outlined: {
                transform: 'translate(8px, 8px) scale(1)'
            }
        },
        MuiInputBase: {
            root: { fontSize: '.8rem' }
        },
        MuiListSubheader: {
            root: { lineHeight: 'unset' }
        },
        MuiMenuItem: {
            root: { fontSize: '0.8rem' }
        },
        PrivateNotchedOutline: {
            legendLabelled: { fontSize: 'unset' }
        },
        MuiTab: {
            root: {
                '@media (min-width: 600px)': { minWidth: 'unset' },
                width: 'min-content',
                whiteSpace: 'nowrap',
                padding: '0 10px'
            }
        },
        MuiButton: {
            outlined: {
                padding: '3px 10px',
                textTransform: 'none'
            }
        },
        MuiFormControlLabel: {
            label: {
                fontSize: 12,
                fontWeight: 600
            }
        }
    }
});
